import React, { useEffect, useMemo, useParams, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { Box, Button, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { Card } from "@mui/material";
import TableMaestros from "verticales/TableMaestros.tsx";
import fetchData from "verticales/FetchData";
import UtilModal from "verticales/UtilModalDisponibilidad.js";
import ViewData from "./componentes/ViewArtefactos.js";
import AppLoading from "verticales/AppLoading.tsx";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import Tooltip from "@mui/material/Tooltip";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 54,
  pl: 2,
  pr: 2,
  pt: 0,
  pb: 2,
};

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "ec2-disponibilidad";

function Dashboard(props: any) {
  // declaracion de variables de la pantalla
  const [data, setData] = useState([]);

  useEffect(() => {
    const catData = async () => {
      try {
        setBlocking(true);
        const data = await fetchData(url, context, { action: "get" });
        setData(data.rows);
        setBlocking(false);
      } catch (err) {
        console.log("Error al traer la data...", err);
      }
    };
    catData();
  }, []);

  /** Segmento de la ventana emergente  */
  const [rowSelect, setRowSelect] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const [blocking, setBlocking] = useState(false);

  const handleOpenModal = (row) => {
    setRowSelect(row);
    setOpenModal(true);
  };

  const handleCloseModal = async (refresh) => {
    setOpenModal(false);
  };
  const renderView = () => {
    return <ViewData row={rowSelect} handleCloseModal={handleCloseModal} />;
  };

  const columns = useMemo(
    () => [
      { header: "cuenta", accessorKey: "cuenta" },
      { header: "database", accessorKey: "name_database" },
      { header: "storage", accessorKey: "tamano" },
      { header: "nro_instancias", accessorKey: "nro_instancias" },
      { header: "nro_compañias", accessorKey: "nro_companias" },
      { header: "usuarios_concurrentes", accessorKey: "usuarios_concurrentes_db" },
      { header: "estado", accessorKey: "estado" },
      { header: "rds_id", accessorKey: "rds_id" },
      { header: "rds_class", accessorKey: "rds_class" },
      { header: "Engine", accessorKey: "engine" },
      { header: "ip_rds", accessorKey: "ip_database" },
    ],
    []
  );

  let renderOpcRowsSid = (row) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%", padding: "0" }}>
        <Tooltip title="Ver">
          <IconButton onClick={() => handleOpenModal(row)}>
            <AnalyticsIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              {blocking ? (
                <AppLoading titleCustom={"ec2-disponibilidad"} />
              ) : (
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox m={1}>
                    <React.Fragment>
                      <TableMaestros
                        arrayColumns={columns}
                        data={data}
                        handleOpenModal={handleOpenModal}
                        height={250}
                        renderOpcRows={renderOpcRowsSid}
                      />
                    </React.Fragment>
                  </MDBox>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderView}
      />
    </DashboardLayout>
  );
}

export default Dashboard;
